// Bottom action buttons on /access, in place of the bottom dock.
//
// The client did not want the permanent bottom tab bar on the "Choose a
// Projector to View" screen, but its projector actions (Request New Access /
// Manage Projectors) still have to be reachable. These two chips now sit
// centered at the bottom and are shown by default — previously they were tucked
// behind a floating "+" that had to be tapped to reveal them.
import React from 'react';
import { motion } from 'motion/react';
import './AccessActionsFab.css';

const SPRING = { type: 'spring', stiffness: 460, damping: 32, mass: 0.7 };

// actions: [{ key, label, icon: Component, onClick }]
const AccessActionsFab = ({ actions = [] }) => {
  if (!actions.length) return null;

  return (
    <div className="afab-root">
      <div className="afab-bar">
        {actions.map(({ key, label: chipLabel, icon: Icon, onClick }) => (
          <motion.button
            key={key}
            type="button"
            className="afab-chip"
            onClick={onClick}
            title={chipLabel}
            aria-label={chipLabel}
            whileTap={{ scale: 0.95 }}
            transition={SPRING}
          >
            <span className="afab-chipIcon">{Icon ? <Icon size={18} /> : null}</span>
            <span className="afab-chipLabel">{chipLabel}</span>
          </motion.button>
        ))}
      </div>
    </div>
  );
};

export default AccessActionsFab;
